const ETA_KEY = 'drivershare:stopEta:v1'
const EARNINGS_KEY = 'drivershare:orderEarnings:v1'
const EARNINGS_TTL_MS = 24 * 60 * 60 * 1000 // keep order earnings for 1 day (same as server)

let _eta = null
let _dirty = false

let _earnings = null
let _earningsDirty = false

/* ---------------- Stop ETA ---------------- */

function etaMap() {
    if (!_eta) {
        try {
            _eta = JSON.parse(localStorage.getItem(ETA_KEY)) || {}
        } catch (e) {
            _eta = {}
        }
    }
    return _eta
}

function save() {
    if (_dirty) return
    _dirty = true
    setTimeout(() => {
        _dirty = false
        try {
            localStorage.setItem(ETA_KEY, JSON.stringify(_eta || {}))
        } catch (e) {
            _eta = _eta || {}
        }
    }, 200)
}

export function hydrateStop(stop) {
    if (!stop || stop.id == null) return stop

    const map = etaMap()
    const key = String(stop.id)

    if (stop.eta) {
        if (map[key] !== stop.eta) {
            map[key] = stop.eta
            save()
        }
    } else if (map[key]) {
        stop.eta = map[key]
    }

    return stop
}

export function hydrateStops(stops) {
    ;(stops || []).forEach(hydrateStop)
    return stops
}

/* ---------------- Order earnings (order_total) ---------------- */

// Loads the map once and drops entries older than 1 day
function earningsMap() {
    if (!_earnings) {
        try {
            _earnings = JSON.parse(localStorage.getItem(EARNINGS_KEY)) || {}
        } catch (e) {
            _earnings = {}
        }

        const now = Date.now()
        let pruned = false
        Object.keys(_earnings).forEach(key => {
            const entry = _earnings[key]
            if (!entry || !entry.t || now - entry.t > EARNINGS_TTL_MS) {
                delete _earnings[key]
                pruned = true
            }
        })
        if (pruned) saveEarnings()
    }
    return _earnings
}

function saveEarnings() {
    if (_earningsDirty) return
    _earningsDirty = true
    setTimeout(() => {
        _earningsDirty = false
        try {
            localStorage.setItem(EARNINGS_KEY, JSON.stringify(_earnings || {}))
        } catch (e) {
            _earnings = _earnings || {}
        }
    }, 200)
}

// Remember earnings when the order has them, fill them in when it doesn't
export function hydrateOrder(order) {
    if (!order || order.id == null) return order

    const map = earningsMap()
    const key = String(order.id)
    const entry = map[key]

    if (order.order_total != null) {
        if (!entry || entry.order_total !== order.order_total) {
            map[key] = { order_total: order.order_total, t: Date.now() }
            saveEarnings()
        }
    } else if (entry && Date.now() - entry.t <= EARNINGS_TTL_MS) {
        order.order_total = entry.order_total
    }

    return order
}

/* ---------------- Shift ---------------- */

export function hydrateShift(shift) {
    if (!shift) return shift
    ;(shift.routes || []).forEach(r => hydrateStops(r.stops))
    ;(shift.active_routes || []).forEach(r => hydrateStops(r.stops))
    ;(shift.orders || []).forEach(o => {
        hydrateOrder(o)
        hydrateStops(o.stops)
    })
    return shift
}

export function clearEtaCache() {
    _eta = {}
    try {
        localStorage.removeItem(ETA_KEY)
    } catch (e) {
        _eta = {}
    }
}

export function clearEarningsCache() {
    _earnings = {}
    try {
        localStorage.removeItem(EARNINGS_KEY)
    } catch (e) {
        _earnings = {}
    }
}